/* istanbul ignore file */
import CheckboxInput from './CheckboxInput';

export default CheckboxInput;
